import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getSession, setSession as storeSession } from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import AuthGate from "@/components/AuthGate";
import Dashboard from "@/pages/Dashboard";
import Archives from "@/pages/Archives";
import Report from "@/pages/Report";
import MonthlyReport from "@/pages/MonthlyReport";
import Activity from "@/pages/Activity";

function App() {
  const [session, setSession] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const guest = params.get("guest");
    if (guest) {
      const s = { token: guest, role: "guest", name: "Guest", warehouse: null, freshLink: true };
      storeSession(s);
      window.history.replaceState({}, "", window.location.pathname);
      return s;
    }
    return getSession();
  });

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#F8FAFC]">
        {session ? (
          <>
            <SiteHeader session={session} />
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/archives" element={<Archives />} />
              <Route path="/report/month/:month" element={<MonthlyReport />} />
              <Route path="/report/:date" element={<Report />} />
              <Route path="/activity" element={<Activity />} />
            </Routes>
          </>
        ) : (
          <AuthGate onSuccess={setSession} />
        )}
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
